module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Account Details","saveBtn":"Save Changes","firstName":"First Name","lastName":"Last Name","email":"Email Address"},"de":{"title":"Benutzerdaten","saveBtn":"Speichern","firstName":"Vorname","lastName":"Nachname","email":"Email Adresse"}}')
  delete Component.options._Ctor
}
